import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "widget-container" }
const _hoisted_2 = { class: "display-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InterventionRequest = _resolveComponent("InterventionRequest")!
  const _component_PreventiveOut = _resolveComponent("PreventiveOut")!
  const _component_Estimate = _resolveComponent("Estimate")!
  const _component_Preventive = _resolveComponent("Preventive")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_InterventionRequest, {
            key: _ctx.requestIntervention,
            equipementDemandeInterventionData: _ctx.demandesData,
            equipementDemandeInterventionDataLoading: _ctx.isDemandesInterventionStatsLoading,
            isBim: true,
            title: _ctx.$t('equipement.dashboard.interventionRequest'),
            class: "ombre"
          }, null, 8, ["equipementDemandeInterventionData", "equipementDemandeInterventionDataLoading", "title"]))
        : _createCommentVNode("", true),
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_PreventiveOut, {
            key: 1,
            equipementInterventionNonPreventiveData: _ctx.nonPreventiveData,
            equipementInterventionNonPreventiveLoading: _ctx.isNonPreventiveStatsLoading,
            isBim: true,
            title: _ctx.$t('equipement.dashboard.travaux'),
            class: "ombre"
          }, null, 8, ["equipementInterventionNonPreventiveData", "equipementInterventionNonPreventiveLoading", "title"]))
        : _createCommentVNode("", true),
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_Estimate, {
            key: 2,
            equipementDevisData: _ctx.devisData,
            equipementDevisLoading: _ctx.isDevisStatsLoading,
            isBim: true,
            title: _ctx.$t('equipement.dashboard.devis'),
            class: "ombre"
          }, null, 8, ["equipementDevisData", "equipementDevisLoading", "title"]))
        : _createCommentVNode("", true),
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_Preventive, {
            key: _ctx.preventiveKey,
            equipementInterventionNonPreventiveDataChart: _ctx.preventiveDataChart,
            equipementInterventionNonPreventiveDataCircle: _ctx.preventiveDataCircle,
            equipementInterventionNonPreventiveLoading: 
                    _ctx.isPreventiveStatsCircleLoading || _ctx.isPreventiveStatsChartLoading
                ,
            isBim: true,
            title: _ctx.$t('equipement.dashboard.preventif'),
            class: "ombre"
          }, null, 8, ["equipementInterventionNonPreventiveDataChart", "equipementInterventionNonPreventiveDataCircle", "equipementInterventionNonPreventiveLoading", "title"]))
        : _createCommentVNode("", true)
    ])
  ]))
}